import axios from 'axios'

const Sentry = {

    async hasPermission(resource) {
        
        for (var a = 1; a < arguments.length; a++) {
            var action = arguments[a];
            var result = await axios.get(`/SoftPro.Sentry/Permissions/Assert?resource=${resource}&action=${action}`, {
                validateStatus: function (status) { return status == 200 || status == 403 }
            });

            if (result.status == 200) {
                return true;
            }
        }
        return false;
    },

    async getPermissions(resource) {
        //get the permissions
        resource = "b6d0e186-b9d2-460a-85e0-a42df1930127";
        var results = (await axios.get(`/SoftPro.Sentry/Permissions?appId=${resource}`)).data;

        //TODO: transform them? We need to get user info beyond just a guid

        return results;
    }
}

export { Sentry };
